// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainAuth {
  height: 100vh;
  max-width: 500px;
  margin: 0 auto;
  /* margin-top: 33px; */
  padding: 33px 47px 0 47px;
  background: #FFE8AE;
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  /* justify-content: center; */
  gap: 33px;
}

.nameAuth {
  font-size: 36px;
  color: #FF6B00;
  font-weight: 700;
  /* margin: auto auto; */
  text-align: center;
}

.infoApp {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.infoItem {
  color: #4B2D10;
}

.infoItem div {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
}

.infoItem span {
  /* color: #4B2D10; */
  font-weight: 700;
  font-size: 24px;
  line-height: 1;
}

.infoItem p {
  font-size: 20px;
}

.AuthButton {
  width: 100%;
  max-width: 400px;
  /* width: 331px; */
  min-height: 60px;
  border-radius: 8px;
  background: #FF6B00;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  /* margin: auto auto; */
  font-family: Alegreya Sans;
  font-size: 24px;
  font-weight: 500;
  line-height: 10px;
  text-align: center;
  color: #FFF4D9;
}

.OpisAuth {
  font-size: 14px;
  font-family: Alegreya Sans;
  margin: auto auto;
  text-align: center;
  margin-bottom: 8px;
}

.OpisAuth a {
  text-decoration: none;
  color: #4B2D10;
  font-weight: 700;
}

/* .texti {
  display: flex;
  align-items: center;
} */

.AuthDown {
  width: 100%;
  margin-top: auto;
  margin-bottom: 34px;
  /*padding: -20px;*/
  /* margin-bottom: 10px; */
}

/* .Link {
  text-decoration: none;
} */`, "",{"version":3,"sources":["webpack://./src/components/Auth/Auth.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;GAGG;;AAEH;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;GAEG","sourcesContent":[".mainAuth {\n  height: 100vh;\n  max-width: 500px;\n  margin: 0 auto;\n  /* margin-top: 33px; */\n  padding: 33px 47px 0 47px;\n  background: #FFE8AE;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  align-items: center;\n  /* justify-content: center; */\n  gap: 33px;\n}\n\n.nameAuth {\n  font-size: 36px;\n  color: #FF6B00;\n  font-weight: 700;\n  /* margin: auto auto; */\n  text-align: center;\n}\n\n.infoApp {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n\n.infoItem {\n  color: #4B2D10;\n}\n\n.infoItem div {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 12px;\n}\n\n.infoItem span {\n  /* color: #4B2D10; */\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 1;\n}\n\n.infoItem p {\n  font-size: 20px;\n}\n\n.AuthButton {\n  width: 100%;\n  max-width: 400px;\n  /* width: 331px; */\n  min-height: 60px;\n  border-radius: 8px;\n  background: #FF6B00;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  /* margin: auto auto; */\n  font-family: Alegreya Sans;\n  font-size: 24px;\n  font-weight: 500;\n  line-height: 10px;\n  text-align: center;\n  color: #FFF4D9;\n}\n\n.OpisAuth {\n  font-size: 14px;\n  font-family: Alegreya Sans;\n  margin: auto auto;\n  text-align: center;\n  margin-bottom: 8px;\n}\n\n.OpisAuth a {\n  text-decoration: none;\n  color: #4B2D10;\n  font-weight: 700;\n}\n\n/* .texti {\n  display: flex;\n  align-items: center;\n} */\n\n.AuthDown {\n  width: 100%;\n  margin-top: auto;\n  margin-bottom: 34px;\n  /*padding: -20px;*/\n  /* margin-bottom: 10px; */\n}\n\n/* .Link {\n  text-decoration: none;\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
